import React from 'react';
import './Container.css';

interface ContainerProps {
  children: React.ReactNode;
  title?: string;
  vertical?: boolean;
}

const Container: React.FC<ContainerProps> = ({ children, title, vertical }) => {
  return (
    <div className="container">
      {title && <h2 className="container-title">{title}</h2>}
      <div className={`container-content ${vertical ? 'vertical' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default Container;